"use strict";
var Observable_1 = require("../../Observable");
var forkJoin_1 = require("../../observable/forkJoin");
Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
//# sourceMappingURL=forkJoin.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/forkJoin.js
 ** module id = 202
 ** module chunks = 1
 **/